export default '$$joy';